import { render, staticRenderFns } from "./PaginationAdminPanel.vue?vue&type=template&id=0bd9b0f0&scoped=true"
import script from "./PaginationAdminPanel.vue?vue&type=script&lang=ts"
export * from "./PaginationAdminPanel.vue?vue&type=script&lang=ts"
import style0 from "./PaginationAdminPanel.vue?vue&type=style&index=0&id=0bd9b0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd9b0f0",
  null
  
)

export default component.exports